module.exports = __webpack_public_path__ + "static/media/CRIM.a891793b.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/books/CRIM.jpg
// module id = 1316
// module chunks = 1